import ContentForm from '../../../components/ContentForm/Index.vue'

export default {
  name: 'HowToPublishClasses',
  components: {
    ContentForm,
  },
}
